module.exports = __webpack_public_path__ + "img/img_7.b87bd467.png";